import { ChevronDown } from 'lucide-react';
import Link from 'next/link';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { authClient } from '@/lib/auth-client';

const Header = () => {
  const { data: session } = authClient.useSession();

  return (
    <div className="px-4">
      <div className="flex h-16 items-center justify-between">
        <Link href="/">
          <div className="flex items-center gap-2">
            <img src="/emblem.svg" alt="" className="h-8" />
            <span className="cursor-pointer text-lg">
              Royal Rangers Sponsorenlauf
            </span>
          </div>
        </Link>

        {session && (
          <DropdownMenu>
            <DropdownMenuTrigger className="hover:bg-accent inline-flex items-center gap-1 rounded-md bg-transparent px-3 py-2 text-sm">
              {session?.user.email}
              <ChevronDown className="h-4 w-4" />
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem onClick={() => authClient.signOut()}>
                Abmelden
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </div>
    </div>
  );
};

export default Header;
